import React from "react";
import { NavLink } from "react-router-dom";
import RowBannerStates, { RowBannerProps } from "./RowBanner.models";
import './RowBanner.scss';

export default class RowBanner extends React.PureComponent<RowBannerProps, RowBannerStates>{


    render(): React.ReactNode {
        let { bannerDetail } = this.props;
        let bannerStyle = { backgroundImage: `url(${bannerDetail.imageSource})` };
        
        return <>
            <NavLink to={bannerDetail.redirectLink}>
                <div className="row row-banner-area">
                    <div className="col-12 px-0" >
                        <div className="box-area image-box-content" style={bannerStyle}>
                            <label>{bannerDetail.title}</label>
                        </div>
                    </div>
                </div>
            </NavLink>
        </>;
    }
}